import React, { useState } from "react";
import InputField from "../components/InputField";
import Button from "../components/Button";
import DropDownMenu from "../components/DropDownMenu";
import { RiDeleteBin6Line } from "react-icons/ri";
import toast from "react-hot-toast";
import { useSelector, useDispatch } from "react-redux";
import {
  getRowsToAvoid,
  getColumnsToAvoid,
  setRowsToAvoid,
  setColumnsToAvoid,
  removeRowToAvoid,
  removeColumnToAvoid,
  saveFileSettingsHeader,
  deleteHeaderRow,
  setSortColumn,
  removeSortColumn,
  getSortColumnSettings,
} from "../store/workspaceSlice";
import CheckBox from "../components/CheckBox";
const initialSettingObject = {
  sortColumnName: "",
  sortColumnType: "",
  order: "",
  toggleSortButton: false,
};
const FileSettingPage = () => {
  const dispatch = useDispatch();
  const sortColumnSettings = useSelector(getSortColumnSettings);
  const rowsToAvoid = useSelector(getRowsToAvoid);
  const columnsToAvoid = useSelector(getColumnsToAvoid);
  const [rowInput, setRowInput] = useState("");
  const [columnInput, setColumnInput] = useState("");
  const [headerRow, setheaderRow] = useState("");
  const [sortingObject, setSettingObject] = useState(
    sortColumnSettings || initialSettingObject
  );

  // Add row to Redux state
  const addRow = () => {
    const rowNumber = parseInt(rowInput, 10);
    if (rowNumber && !rowsToAvoid.includes(rowNumber)) {
      dispatch(setRowsToAvoid(rowNumber));
    }
    setRowInput("");
  };

  // Remove row from Redux state
  const removeRow = (rowToRemove) => {
    dispatch(removeRowToAvoid(rowToRemove));
  };

  // Add column to Redux state
  const addColumn = () => {
    const columnNumber = parseInt(columnInput, 10);
    if (columnNumber && !columnsToAvoid.includes(columnNumber)) {
      dispatch(setColumnsToAvoid(columnNumber));
    }
    setColumnInput("");
  };

  // Remove column from Redux state
  const removeColumn = (columnToRemove) => {
    dispatch(removeColumnToAvoid(columnToRemove));
  };
  const handleOnChange = (e) => {
    setSettingObject({ ...sortingObject, [e.target.name]: e.target.value });
  };

  return (
    <div className="">
      <div className=" grid grid-cols-2 gap-4 p-2">
        {/* Header  */}
        <div className="col-span-2 flex items-end gap-2">
          <div className=" flex-1">
            <InputField
              label={"Enter Header Row"}
              key={""}
              type="number"
              value={headerRow}
              placeholder={"Enter header row number"}
              onChange={(e) => {
                const value = parseInt(e.target.value, 10);
                if (value >= 0) {
                  setheaderRow(value);
                }
              }}
            />
          </div>
          <div className="">
            <Button
              disabled={headerRow === undefined || !headerRow}
              btnText={"Add Header Row"}
              handleOnClick={() => {
                dispatch(saveFileSettingsHeader(headerRow)); // save header row directly to redux
              }}
            />
          </div>
          <div className="">
            <Button
              btnType="cancel"
              // disabled={headerRow === undefined || !headerRow}
              btnText={"Reset Header"}
              handleOnClick={() => {
                dispatch(deleteHeaderRow()); //delete header row from redux
                setheaderRow("");
              }}
            />
          </div>
        </div>
        {/* Rows */}
        <div>
          <div className="flex flex-col gap-y-2 ">
            <InputField
              label={"Specify Rows to Ignore"}
              key={""}
              type="number"
              placeholder={"Enter row number"}
              value={rowInput}
              onChange={(e) => {
                const value = parseInt(e.target.value, 10);
                if (value >= 0) {
                  setRowInput(value);
                }
              }}
            />
            <Button
              btnText={"Add Row"}
              handleOnClick={addRow}
              disabled={!rowInput}
            />
          </div>

          {/* Show list of Rows to ignore */}
          <div className="h-48 bg-gray-200 p-2 rounded-md mt-2">
            <h3 className="text-center font-bold text-gray-700 underline">
              Rows to ignore
            </h3>
            <ul className="list-disc list-inside max-h-40 min-h-30 overflow-y-auto p-2">
              {rowsToAvoid.map((row, index) => (
                <li
                  key={index}
                  className="flex justify-between items-center bg-gray-100 p-1 my-1 rounded"
                >
                  <span className="px-1">Row {row} </span>
                  <button
                    className="text-red-500 px-2 hover:text-red-800"
                    onClick={() => removeRow(row)}
                  >
                    <RiDeleteBin6Line />
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
        {/* Columns */}
        <div>
          <div className="flex flex-col  gap-y-2  ">
            <InputField
              label={"Specify Columns to Ignore"}
              key={""}
              type="number"
              placeholder="Enter column number"
              value={columnInput}
              onChange={(e) => {
                const value = parseInt(e.target.value, 10);
                if (value >= 0) {
                  setColumnInput(value);
                }
              }}
            />
            <Button
              btnText={"Add Column"}
              handleOnClick={addColumn}
              disabled={!columnInput}
            />
          </div>

          {/* Show list of columns to ignore */}
          <div className="h-48 bg-gray-200 p-2 rounded-md mt-2">
            <h3 className="text-center font-bold text-gray-700 underline">
              Columns to ignore
            </h3>
            <ul className="list-disc list-inside max-h-40 min-h-30 overflow-y-auto p-2">
              {columnsToAvoid.map((column, index) => (
                <li
                  key={index}
                  className="flex justify-between items-center bg-gray-100 p-1 my-1 rounded"
                >
                  <span>Column {column} </span>
                  <button
                    className="text-red-500 hover:text-red-800"
                    onClick={() => removeColumn(column)}
                  >
                    <RiDeleteBin6Line />
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="col-span-2 flex justify-start items-center gap-x-8 my-1">
        <div className="min-h-10 flex">
          <CheckBox
            name={"toggleSortButton"}
            chkBoxText={"Sort File by Column"}
            checked={sortingObject.toggleSortButton}
            onChange={(e) => {
              const value = e.target.checked;
              setSettingObject({
                ...sortingObject,
                toggleSortButton: value,
              });
            }}
          />
        </div>
      </div>
      <div
        className={`grid grid-cols-1 xl:grid-cols-2 gap-4 transition-all duration-500 ${
          !sortingObject.toggleSortButton
            ? "opacity-0 max-h-0 overflow-hidden"
            : "opacity-100 max-h-screen"
        }`}
      >
        <InputField
          label={"Enter Column Name to Sort"}
          key={""}
          type="text"
          name="sortColumnName"
          value={sortingObject.sortColumnName}
          placeholder={"Enter column name"}
          onChange={(e) => {
            const value = e.target.value
              .replace(/[^a-zA-Z]/g, "")
              .toUpperCase()
              .trim();
            e.target.value = value;
            handleOnChange(e);
          }}
          required
        />
        <DropDownMenu
          label="Select Column Data type"
          name="sortColumnType"
          value={sortingObject.sortColumnType}
          options={[
            { label: "Alphabetic", value: "alphabetic" },
            { label: "Numeric", value: "numeric" },
            { label: "Date", value: "date" },
          ]}
          onChange={(e) => handleOnChange(e)}
          required
        />
        <DropDownMenu
          label="Sort Type"
          name="order"
          value={sortingObject.order}
          options={[
            { label: "Ascending", value: "asc" },
            { label: "Descending", value: "des" },
          ]}
          onChange={(e) => handleOnChange(e)}
          required
        />
        <div className="flex gap-4 w-full col-span-2">
          <Button
            disabled={
              !sortingObject.sortColumnName ||
              !sortingObject.sortColumnType ||
              !sortingObject.order
            }
            btnText={"Save"}
            handleOnClick={() => {
              dispatch(setSortColumn(sortingObject));
              toast.success("Sort settings saved successfully");
            }}
          />
          <Button
            btnType="cancel"
            disabled={
              !sortingObject.sortColumnName ||
              !sortingObject.sortColumnType ||
              !sortingObject.order
            }
            btnText={"Reset"}
            handleOnClick={() => {
              dispatch(removeSortColumn());
              toast.success("Sort settings removed successfully");
              setSettingObject(initialSettingObject);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default FileSettingPage;
